module.exports = __webpack_public_path__ + "img/new7.d279ba3a.png";